import { Merge } from '@graphcommerce/ecommerce-ui'
import { extendableComponent, filterByTypename } from '@graphcommerce/next-ui'
import { Box, SxProps, Theme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { DefaultPageQuery } from '../../../graphql/DefaultPage.gql'
import { ProductPage2Query } from '../../../graphql/ProductPage2.gql'
import { RowProduct } from '../../GraphCMS/RowProduct/RowProduct'

type ProductType = Merge<
  NonNullable<NonNullable<NonNullable<ProductPage2Query['products']>['items']>[0]>,
  NonNullable<NonNullable<NonNullable<ProductPage2Query['relatedUpsells']>['items']>[0]>
>

type PromoSidebarProps = {
  pages: NonNullable<DefaultPageQuery['pages']>
  product: ProductType
  sx?: SxProps<Theme>
}

const name = 'PromoSidebar' as const
const parts = ['root', 'item'] as const
const { classes } = extendableComponent(name, parts)

export function PromoSidebar(props: PromoSidebarProps) {
  const { pages, product, sx } = props
  const pagesContent = filterByTypename(pages?.[0].content, 'RowProduct')
  const promotionProducts = product?.promotion_products
  const promotionContent = pagesContent?.filter((item) => item?.variant === 'Grid') ?? []
  const upsellProducts = pagesContent?.filter((item) => item?.variant === 'Upsells') ?? []
  const isPromotionProduct = promotionProducts && promotionProducts.length > 0
  const isMobile = useMediaQuery('(max-width:1299px)')

  return (
    <Box
      className={classes.root}
      sx={[
        (theme) => ({
          mt: theme.spacings.lg,
          pl: theme.spacings.md,
          '@media (min-width: 1300px)': {
            pl: { md: theme.spacings.md, lg: theme.spacings.lg },
            mt: 0,
          },
          '& .ContainerWithHeader-title': {
            ...theme.typography.h2,
            fontWeight: 300,
            textTransform: 'none',
          },
          '& .ContainerWithHeader-head': {
            mb: theme.spacings.sm,
          },
          '& .MuiContainer-root': {
            p: 0,
            m: 0,
          },
          '& .price': {
            fontSize: theme.typography.h2,
            fontWeight: 700,
          },

          '& .MuiTypography-subtitle1.ContainerWithHeader-right': {
            display: 'none',
          },
          '& .ProductListItem-title, & .ProductListItem-root .MuiTypography-caption': {
            fontFamily: 'inherit',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <RowProduct
        {...promotionContent[0]}
        sx={(theme) => ({
          '@media (min-width: 1300px)': {
            gridTemplateColumns: '180px 180px',
            gap: { md: theme.spacings.sm, lg: theme.spacings.md },
          },
        })}
        productUrlKeys={[]}
        title={isPromotionProduct ? 'Onderdeel van deze actie' : 'Anderen kochten ook'}
        pageLinks={
          isPromotionProduct ? promotionContent[0]?.pageLinks : upsellProducts[0].pageLinks
        }
        productCopy={
          isPromotionProduct ? promotionContent[0]?.productCopy : upsellProducts[0]?.productCopy
        }
        items={isPromotionProduct ? promotionProducts : product?.upsell_products?.slice(0, 10)}
        variant={isMobile ? 'Swipeable' : 'Grid'}
        {...product}
      />
      {!isPromotionProduct && <Box id='squeezely-products-wrapper' />}
    </Box>
  )
}
